module.exports = __webpack_public_path__ + "static/media/CH.90baef9d.png";